// extracted by mini-css-extract-plugin
export default {"leave-request-container":"LeaveRequest_leave-request-container__vpccq","leave-request-header__buttons":"LeaveRequest_leave-request-header__buttons__t7vlq"};